<template>
  <div id="CanvasCorrect">

    <div class="wrapper">
      <div class="container" id="container" style="max-with:640px; width:100%">
        <div class="canvas-container" style="background-size: contain; background-repeat: no-repeat; height:100%; width:auto">

          <!-- <div id="stage" style="position: absolute;z-index: 9;"></div> -->

          <!-- <v-stage :config="configKonva">
            <v-layer>
              <v-circle :config="configCircle"></v-circle>
            </v-layer>
          </v-stage> -->

          <div id="stage" style="width:auto; height:100%"></div>


            <!-- <v-stage
            ref="stage"
            :config="configKonva"
            @dragstart="handleDragstart"
            @dragend="handleDragend"
          >
            <v-layer ref="layer">
              <v-star
                v-for="item in list"
                :key="item.id"
                :config="{
                  x: item.x,
                  y: item.y,
                  rotation: item.rotation,
                  id: item.id,
                  numPoints: 5,
                  innerRadius: 30,
                  outerRadius: 50, fill: '#89b717',
                  opacity: 0.8,
                  draggable: true,
                  scaleX: dragItemId === item.id ? item.scale * 1.2 : item.scale,
                  scaleY: dragItemId === item.id ? item.scale * 1.2 : item.scale,
                  shadowColor: 'black',
                  shadowBlur: 10,
                  shadowOffsetX: dragItemId === item.id ? 15 : 5,
                  shadowOffsetY: dragItemId === item.id ? 15 : 5,
                  shadowOpacity: 0.6
                }"
              ></v-star>
            </v-layer>
          </v-stage> -->


          <!-- <canvas id="obudowa" width="640" height="640" ref="canRef"></canvas>

          <canvas id="centrala" width="640" height="640"></canvas>

          <canvas id="modul" width="640" height="640"></canvas> -->
        </div>
      </div>
    </div>

    <div style="padding: 20px 0px;">
      <!-- <span style="margin:2px 10px;"><b>x:</b> <input style="width:80px" type="number" v-model="odchylkaX" step=".1"/></span>
      <span style="margin:2px 10px;"><b>y:</b> <input style="width:80px" type="number" v-model="odchylkaY" step=".1"/></span> -->

      <table id="tabCorrect" style="width: 240px;text-align: center;margin: 10px auto;">
        <tr style="background: chocolate;color: white;height: 50px;">
          <td style="width:40px">obecne</td><td style="width:40px">korekta</td>
        </tr>
        <tr style="background: antiquewhite;">
          <td>x: <b>{{Number(aXY['oldX']).toFixed(2)}}</b></td><td>x: <b>{{Number(aXY['newX']).toFixed(2)}}</b></td>
        </tr>
        <tr style="background: #f0d9bb;">
          <td>y: <b>{{Number(aXY['oldY']).toFixed(2)}}</b></td><td>y: <b>{{Number(aXY['newY']).toFixed(2)}}</b></td>
        </tr>
        <tr>
          <td colspan="2">
            <md-button class="md-default" @click="saveCorrectCanvas(typ)">zapisz  </md-button>
          </td>
        </tr>
      </table>
    </div>

  </div>
</template>

<script>
const width = 640; // window.innerWidth;
const height = 640; // window.innerHeight;

import { mapGetters } from "vuex";

export default {
  name: "CanvasCorrectTest",
  // props: ["obudowa", "plytka", "modul", "modulIndex", "eyes"],
  props: ["powiazanie","typ"],
  data() {
    return {
      configKonva: {
        width: width,
        height: height
      },
      list: [],
      dragItemId: null,
      configHoles: {
        name: 'hole',
        x: 0,
        y: 0,
        radius: 4,
        fill: 'red',
        stroke: '#fff',
        strokeWidth: 1,
      },
      objSize: 100,
      stage: '',
      container: '',
      aXY: {
        oldX: 0,
        oldY: 0,
        newX: 0,
        newY: 0
      },
      odchylkaX: 0,
      odchylkaY: 0,
      inWidth: 0,
      // width2: document.documentElement.clientWidth,
      // height2: document.documentElement.clientHeight

      // msg: "Montaż central",
      // canvas: null,
      // centrala: {
      //   x: 0,
      //   y: 0,
      //   width: 0,
      //   height: 0,
      // },
      // odchylkaKat: 0,
      // katTmp: 0,
      // mySVG: require("../assets/AWO000.svg"),

      // --------------------
      // layer: '',
      // objects: [],
      // lastId: 0,
      // connFrom: '',

      // configHandle: {
      //   name: 'handle',
      //   x: 0,
      //   y: 0,
      //   radius: 5,
      //   fill: 'green',
      //   stroke: '#fff',
      //   strokeWidth: 0,
      // },
      // image: null,
      // stageSize: {
      //   width: width,
      //   height: height
      // },
      // --------------------

      // configKonva: {
      //   width: 200,
      //   height: 200
      // },
      // configCircle: {
      //   x: 100,
      //   y: 100,
      //   radius: 70,
      //   fill: "red",
      //   stroke: "black",
      //   strokeWidth: 4
      // }

    };
  },
  directives: {
    // loadImage(canvasElement, binding,vnode) {
    // 	vnode.context.canvas = canvasElement
    //   const ctx = canvasElement.getContext('2d')
    //   const image = new Image()
    //   image.src = '../assets/awo000.jpg'
    //   image.onload = () => {
    //     ctx.drawImage(image, 0, 0, 500, 500)
    //   }
    // }
  },
  computed: {
    // ...mapGetters("products", [
    //   "inputData",
    //   "modulSelected",
    //   "selectedElements",
    // ]),
    ...mapGetters("products", [
      "obudowy",
      "centrale",
      "moduly",
    ])
    // compIndexModul() {
    //   return this.modulIndex;
    // },
    // daneObudowa () {
    //   return this.obudowy.filter(item => item.id_obudowa == this.powiazanie.id_obudowa)
    // },
    // daneCentrala () {
    //   return this.centrale.filter(item => item.idcentrala == this.powiazanie.id_centrala)
    // },
    // daneModul () {
    //   return this.moduly.filter(item => item.idmodul == this.powiazanie.id_modul)
    // }
  },
  watch: {
    odchylkaX() {
      // this.viewMontaz();
      this.dragdropCanvasTestClass()
    },
    odchylkaY() {
      // this.viewMontaz();
      this.dragdropCanvasTestClass()
    },
    // odchylkaKat() {
    //   // this.viewMontaz();
    // },
    // eyes(newValue, oldValue) {
    //   this.viewMontaz();
    // },
    powiazanie(newValue, oldValue) {
      // this.viewMontaz();
      this.dragdropCanvasTestClass()
    }
  },
  methods: {
    saveCorrectCanvas(e) {
      this.powiazanie.wspX = this.aXY.newX
      this.powiazanie.wspY = this.aXY.newY
      if (e === 'centrala') {
        this.$store.dispatch('products/send_connection_centrale', {'action': 'edit', 'fields': this.powiazanie})
      } else if (e === 'modul') {
        this.$store.dispatch('products/send_connection_moduly', {'action': 'edit', 'fields': this.powiazanie})
      }
    },
    dragdropCanvasTest () {
      // console.log('------ dragdropCanvasTest --------')
      // // const stage = this.$refs.stage.getNode();
      // // const layer = this.$refs.layer.getNode();
      // // const rect = this.$refs.rect.getNode();
      // for (let n = 0; n < 5; n++) {
      //   this.list.push({
      //     id: Math.round(Math.random() * 10000).toString(),
      //     x: Math.random() * width,
      //     y: Math.random() * height,
      //     rotation: Math.random() * 180,
      //     scale: Math.random()
      //   });
      // }
    },
    dragdropCanvasTestClass () {
      console.log('----- dragdropCanvasTestClass -----')
			const v = this;
      var enclosures = []
      var controlPanel = []

      if (this.obudowy) {
        enclosures = this.obudowy.filter(item => (item.id_obudowa === this.powiazanie.id_obudowa))[0]
         // this.centrale.filter(item => (item.idcentrala === this.powiazanie.id_centrala))[0]

        var kolor = ''

        if (this.typ === 'modul') {
          controlPanel = this.moduly.filter(item => (item.idmodul === this.powiazanie.id_modul))[0]
          kolor = 'rgba(77,177,79,0.5)'
        } else {
          controlPanel = this.centrale.filter(item => (item.idcentrala === this.powiazanie.id_centrala))[0]
          kolor = 'rgba(255,0,0,.4)'
        }

        // // var module = (this.selectedElements['moduly'] && this.selectedElements['moduly'][0]) ? Object.assign({}, this.selectedElements['moduly'][0]) : {}
        // var modules = this.selectedElements["moduly"]
        //   ? Object.assign({}, this.selectedElements["moduly"])
        //   : {};

        this.aXY.oldX = Number(this.powiazanie.wspX)
        this.aXY.oldY = Number(this.powiazanie.wspY)
        this.aXY.newX = Number(this.powiazanie.wspX) + Number(this.odchylkaX)
        this.aXY.newY = Number(this.powiazanie.wspY) + Number(this.odchylkaY)

        v.stage = new Konva.Stage({
          container: 'stage',
          width: width,
          height: height,
        });

        // --------------------------------------- Obudowa
        if (enclosures && Object.keys(enclosures).length>0) {
          var layerObudowa = new Konva.Layer();
          var imageObj = new Image();
          imageObj.onload = function () {

            let loadedImageWidth = imageObj.width;
            let loadedImageHeight = imageObj.height;
            // console.log(loadedImageWidth, loadedImageHeight)
            // console.log(width, height)
            let scale_factor = Math.min(
              width / loadedImageWidth ,
              height / loadedImageHeight
            );

            let newWidth = loadedImageWidth  * scale_factor;
            let newHeight = loadedImageHeight * scale_factor;

            var yoda = new Konva.Image({
              x: 0,
              y: 0,
              width: newWidth,
              height: newHeight,
              image: imageObj,
            });
            layerObudowa.add(yoda);
          };

          var path = ''
          if (this.powiazanie.scianka) {
            var prefix =  (this.powiazanie.scianka === 'C') ? '' : '_' + this.powiazanie.scianka
            path = 'https://lib.pulsar.pl/img/montaz_central/' + enclosures['symbol'] + prefix + '.jpg'
          } else {
            path = 'https://lib.pulsar.pl/img/montaz_central/' + enclosures['symbol'] + '.jpg'
          }
          // imageObj.src = 'https://lib.pulsar.pl/img/montaz_central/'+enclosures['symbol']+'.jpg';
          imageObj.src = path;
          v.stage.add(layerObudowa);

          // --------------------------------------- Centrala

          let radius = 5;
          let wsp = 0;
          var modX = 0;
          var modY = 0;

          if (this.powiazanie.wspX && this.powiazanie.wspY) {
            modX = this.powiazanie.wspX;
            modY = this.powiazanie.wspY;
          }

          let szerokoscObudowy = 0
          let wysokoscObudowy = 0

          if (this.powiazanie.scianka === 'G' || this.powiazanie.scianka === 'D') {
            szerokoscObudowy = Number(enclosures.szerokosc)
            wysokoscObudowy = Number(enclosures.glebokosc)
          } else if (this.powiazanie.scianka === 'L' || this.powiazanie.scianka === 'P') {
            szerokoscObudowy = Number(enclosures.glebokosc)
            wysokoscObudowy = Number(enclosures.wysokosc)
          } else {
            console.log('montaz')
            console.log(enclosures.montaz)
            if (enclosures.montaz === 'podtynkowy') {
              szerokoscObudowy = enclosures.szerokosc_kolnierz
              wysokoscObudowy = enclosures.wysokosc_kolnierz
            } else {
              szerokoscObudowy = enclosures.szerokosc
              wysokoscObudowy = enclosures.wysokosc
            }
          }
          console.log('wymiary: ', szerokoscObudowy, 'x', wysokoscObudowy)

          // let newCentralkaWidth = (layerObudowa.canvas.width * controlPanel.szerokosc) / szerokoscObudowy
          // let newCentralkaHeight = (layerObudowa.canvas.height * controlPanel.wysokosc) / wysokoscObudowy
          let newCentralkaWidth = (width * controlPanel.szerokosc) / szerokoscObudowy
          let newCentralkaHeight = (height * controlPanel.wysokosc) / wysokoscObudowy

          if (szerokoscObudowy >= wysokoscObudowy) {
            // wsp = layerObudowa.canvas.width / szerokoscObudowy;
            // newCentralkaHeight = controlPanel.wysokosc * wsp;
            wsp = width / szerokoscObudowy; // dodane
            newCentralkaWidth = controlPanel.szerokosc * wsp;
            newCentralkaHeight = controlPanel.wysokosc * wsp; // dodane
          } else {
            // wsp = layerObudowa.canvas.height / wysokoscObudowy;
            // newCentralkaWidth = controlPanel.szerokosc * wsp;
            wsp = height / wysokoscObudowy;
            newCentralkaHeight = controlPanel.wysokosc * wsp;
            newCentralkaWidth = controlPanel.szerokosc * wsp;
          }

          console.log('wsp', wsp)

          var obrot = 0
          if (this.powiazanie.o0 === 1 || this.powiazanie.o0 === "1") {
            obrot = 0;
          } else if (this.powiazanie.o90 === 1 || this.powiazanie.o90 === "1") {
            obrot = 90;
          } else if (this.powiazanie.o180 === 1 || this.powiazanie.o180 === "1") {
            obrot = 180;
          } else if (this.powiazanie.o270 === 1 || this.powiazanie.o270 === "1") {
            obrot = 270;
          }

          var pcbX =
            Number(modX * wsp) - Number(controlPanel.p1x * wsp) // + Number(this.odchylkaX * wsp);
          var pcbY =
            Number(modY * wsp) - Number(controlPanel.p1y * wsp) // + Number(this.odchylkaY * wsp);

          var layerCentrala = new Konva.Layer();
          let centrala = new Konva.Group({
            name: 'centrala',
            x: Number(pcbX),
            y: Number(pcbY),
            rotation: obrot,
            width: Number(newCentralkaWidth),
            height: Number(newCentralkaHeight),
            draggable: true
          })
            .add (new Konva.Rect({
              x: 0,
              y: 0,
              width: Number(newCentralkaWidth),
              height: Number(newCentralkaHeight),
              fill: kolor
            })
              .on('mouseenter', function() {
                v.stage.container().style.cursor = 'pointer';
              })
              .on('mouseleave', function() {
                v.stage.container().style.cursor = 'default';
              })
              .on('mousemove', function () {
                // var mousePos = v.stage.getPointerPosition();
                // console.log('x: ' + mousePos.x + ', y: ' + mousePos.y);
              })
            )

          // centrala.rotation(90);
            // .add(v.holeAdd(1, wsp,  [controlPanel.p1x, controlPanel.p1y]))
            // .add(v.holeAdd(1, wsp,  [controlPanel.p2x, controlPanel.p2y]))
            // .add(v.holeAdd(1, wsp,  [controlPanel.p3x, controlPanel.p3y]))
            // .add(v.holeAdd(1, wsp,  [controlPanel.p4x, controlPanel.p4y]))
            // .add(v.holeAdd(1, wsp,  [controlPanel.p5x, controlPanel.p5y]))
            // .add(v.holeAdd(1, wsp,  [controlPanel.p6x, controlPanel.p6y]))

          for (var no = 1; no < 7; no++) {
            if (
              Number(controlPanel["p" + no + "x"]) === 0 &&
              Number(controlPanel["p" + no + "y"]) === 0
            ) {
            } else {
              var pX =
                Number(controlPanel["p" + no + "x"]) * Number(wsp); // + centralka[controlPanel].odchylkaX
              var pY =
                Number(controlPanel["p" + no + "y"]) * Number(wsp);

              let h = new Konva.Circle(v.configHoles);
                h.attrs.id = no;
                h.attrs.lines = {};
                h.attrs.x = pX;
                h.attrs.y = pY;
              centrala.add(h);
            }
          }
          // console.log('modXY', modX, modY)
          // console.log('wsp', wsp)
          // console.log('pcbXY', pcbX, pcbY)
          // console.log('centrala', centrala.attrs.x,centrala.attrs.y)
          // console.log('centrala', centrala.attrs.x/wsp, centrala.attrs.y/wsp)

          centrala.on('dragmove', () => {
            // console.log('centrala', centrala.attrs.x,centrala.attrs.y)
          // console.log('centrala._lastPos.xy', centrala._lastPos.x, centrala._lastPos.y)
          // console.log('centrala._lastPos.xy', (centrala._lastPos.x/wsp), (centrala._lastPos.y))

            this.aXY.newX = centrala.attrs.x/wsp + Number(controlPanel.p1x)
            // this.aXY.newX = Number(v.odchylkaX / wsp).toFixed(2)
            this.aXY.newY = centrala.attrs.y/wsp + Number(controlPanel.p1y)
            // this.aXY.newY = Number(v.odchylkaY / wsp).toFixed(2)
            // console.log('x: ',centrala._lastPos.x, ' ', 'y: ', centrala._lastPos.y);
          })
          var centralaRotate = new Konva.Transformer({
            nodes: [centrala],
            centeredScaling: false,
            rotationSnaps: [0, 90, 180, 270],
            resizeEnabled: false,
          });
          layerCentrala.add(centralaRotate);
          layerCentrala.draw()
          layerCentrala.add(centrala);
          v.stage.add(layerCentrala);
        }
      }
    },
		holeAdd(groupId, wsp, wspXY) {
      console.log('----- holeAdd -----')
			const v = this;
      let h = new Konva.Circle(v.configHoles);
        h.attrs.id = groupId;
        h.attrs.lines = {};

        h.attrs.x = wspXY[0] * wsp;
        h.attrs.y = wspXY[1] * wsp;
      return h;
		},

    // saveCorrectCanvas(e) {
    //   this.powiazanie.wspX = this.aXY.newX
    //   this.powiazanie.wspY = this.aXY.newY
    //   if (e === 'centrala') {
    //     this.$store.dispatch('products/send_centrale', {'action': 'edit', 'fields': this.powiazanie})
    //   } else if (e === 'modul') {
    //     this.$store.dispatch('products/send_moduly', {'action': 'edit', 'fields': this.powiazanie})
    //   }
    // },
    // =========================================================================================== KONVA

		setStateActive(obj){
      console.log('----- setStateActive -----')
			obj.setAttr('strokeWidth', 2);
			this.connFrom = obj;
		},
		setStateNormal(obj){
      console.log('----- setStateNormal -----')
			obj.setAttr('strokeWidth', 5);
			this.connFrom = '';
		},

		handleAdd(groupId, type) {
      console.log('----- handleAdd -----')
			const v = this;

			let h = new Konva.Circle(v.configHandle);
				h.attrs.id = groupId + type;
				h.attrs.lines = {};

			if(type == 't'){ // left top
				h.attrs.x = v.objSize;
				// h.attrs.x = v.objSize.x;
			}
			else if(type == 'r'){
				h.attrs.x = v.objSize;
				h.attrs.y = v.objSize;
			}
			else if(type == 'b'){
				h.attrs.x = 0;
				h.attrs.y = 0;
			}
			else {
				h.attrs.y = v.objSize;
			}

			// hadle add
			h.on ('click', (e) => {
				e.cancelBubble = true;

				if (v.connFrom === '') {
					// no active handle
					v.setStateActive(h)
				} else {
					// exist active handle
					let from = v.connFrom;
					let to = e.target;
					let fromGroup = from.findAncestor('Group');
					let fromGroupId = fromGroup.attrs.id;
					let toGroup = to.findAncestor('Group');
					let toGroupId = toGroup.attrs.id;

					// if !same handle, !same Group, no lines btw from&to Groups
					if (from.attrs.id != to.attrs.id
						&& fromGroupId != toGroupId
						&& !fromGroup.find('.handle').some (
								(h) => Object.keys(h.attrs.lines).some (
									(l) => l.match(/\d+/g).some (
										(oId) => oId == toGroupId
									)
								)
							)
					) v.lineAdd(from, to);

					v.setStateNormal(from);
				}
				v.layer.batchDraw();

			})

			// handle earse
			// .on ('dblclick', (e) => {
			// 	e.cancelBubble = true;
			// 	v.handleEarse(e.target);
			// })

			.on('mouseenter', function() {
				v.stage.container().style.cursor = 'pointer';
			})
			.on('mouseleave', function() {
				v.stage.container().style.cursor = 'default';
			})

			return h;
		},
		objectAdd() {
      console.log('----- objectAdd -----')
			const v = this;

			let obj = new Konva.Group({
				name: 'obj',
				id: v.lastId,
				x: (v.stage.width() - v.objSize) * Math.random() + v.objSize/2,
				y: (v.stage.height() - v.objSize) * Math.random() + v.objSize/2,
				draggable: true,
			})
				.add (new Konva.Rect({
					width: v.objSize,
					height: v.objSize,
					fill: 'rgba(68,114,196,.4)',

				}))
				.add (new Konva.Text({
					y: 35,
					width: v.objSize,
					text: v.lastId,
					fontSize: 20,
					fontFamily: 'Calibri',
					fill: '#fff',
					align: 'center',
				}))
        // kropki po bokach
				.add(v.handleAdd(v.lastId, 't'))
				.add(v.handleAdd(v.lastId, 'r'))
				.add(v.handleAdd(v.lastId, 'b'))
				.add(v.handleAdd(v.lastId, 'l'))


				// obj delete
				// .on ('dblclick', (e) => {
				// 	e.cancelBubble = true;

				// 	e.target.findAncestor('Group').find('.handle').forEach (
				// 		(h) => v.handleEarse(h)
				// 	)

				// 	obj.destroy();
				// 	v.layer.batchDraw();
				// })

				// drag obj
				.on ('dragmove',
					(e) => e.target.find('.handle').forEach (
						(h) => Object.values(h.attrs.lines).forEach (
							(l) => v.lineSetCoords(l)
						)
					)
				);


			v.layer.add(obj);
			v.layer.batchDraw();
			v.lastId++;
		},
		lineAdd (from, to){
      console.log('----- lineAdd -----')
			const v = this;

			let lineId = 'line-'+ from.attrs.id +'-'+ to.attrs.id;
			let line = new Konva.Line({
				id: lineId,
				stroke: 'red',
				strokeWidth: 3,
				from: from,
				to: to,
				hitStrokeWidth: 1,
			})
			// line delete
			// .on ('dblclick', (e) => {
			// 	e.cancelBubble = true;

			// 	let l = e.target;
			// 	delete l.attrs.from.attrs.lines[l.attrs.id];
			// 	delete l.attrs.to.attrs.lines[l.attrs.id];
			// 	l.destroy();

			// 	v.layer.batchDraw();
			// })

			.on('mouseenter', function() {
				v.stage.container().style.cursor = 'pointer';
			})
			.on('mouseleave', function() {
				v.stage.container().style.cursor = 'default';
			})

			let fromLines = from.getAttr('lines');
				fromLines[lineId] = line;
				from.setAttr('lines', fromLines);


			let toLines = to.getAttr('lines');
				toLines[lineId] = line;
				to.setAttr('lines', toLines);

			v.lineSetCoords(line);

			v.layer.add(line);
			v.layer.batchDraw();
		},

		lineSetCoords (line) {
      console.log('----- lineSetCoords -----')
			let v = this;

			let from = line.attrs.from;
			let to = line.attrs.to;

			let fromFullX = from.findAncestor('Group').attrs.x + from.attrs.x
			let fromFullY = from.findAncestor('Group').attrs.y + from.attrs.y
			let toFullX = to.findAncestor('Group').attrs.x + to.attrs.x
			let toFullY = to.findAncestor('Group').attrs.y + to.attrs.y

			let r = v.configHandle.radius + 1;
			let angle = Math.atan2(-(toFullY - fromFullY), toFullX - fromFullX);


			line.setAttr('points', [
				fromFullX - r * Math.cos(angle + Math.PI),
				fromFullY + r * Math.sin(angle + Math.PI),
				toFullX - r * Math.cos(angle),
				toFullY + r * Math.sin(angle),
			])
		},

		handleEarse(h){
      console.log('----- handleEarse -----')
			let lines = h.attrs.lines;
			for (let i in lines){
				let l = lines[i];
				delete l.attrs.from.attrs.lines[l.attrs.id];
				delete l.attrs.to.attrs.lines[l.attrs.id];
				l.destroy();
			}

			this.layer.batchDraw();
		},
    dragdropCanvas () {
      console.log('----- dragdropCanvas -----')
		  const v = this;

      // set stage
      v.stage = new Konva.Stage({
        container: 'stage',
        width: 640,// window.innerWidth,
        height: 640// window.innerHeight,
      })
      // .on ('dblclick', () => {
      //   v.objectAdd();
      // })

      // .on ('click', () => {
      //   console.log('stage click')

      //   if (v.connFrom) {
      //     v.setStateNormal(v.connFrom)
      //     v.layer.batchDraw();
      //   }
      // });

      // var strDataURI = process.env.VUE_APP_ROOT_IMG + "" + this.powiazanie.obudowa + ".jpg";
      // const image = new Image();
      // image.src = "https://konvajs.org/assets/yoda.jpg";
      // image.onload = () => {
      //   // set image only when it is loaded
      //   this.image = image;
      // };

      v.layer = new Konva.Layer();
      v.stage.add(v.layer);
      v.objectAdd();
      v.layer.batchDraw();
    },
    handleDragstart(e) {
      // save drag element:
      this.dragItemId = e.target.id();
      // move current element to the top:
      const item = this.list.find(i => i.id === this.dragItemId);
      const index = this.list.indexOf(item);
      this.list.splice(index, 1);
      this.list.push(item);
    },
    handleDragend(e) {
      this.dragItemId = null;
    },
    getDimensions() {
      // this.width = document.documentElement.clientWidth;
      // this.height = document.documentElement.clientHeight;
      // const elmnt = document.getElementById("container");
      // this.width2 = elmnt.offsetWidth
      // this.height2 = elmnt.offsetHeight
      // console.log(this.width2, this.height2)
    }
  },
  mounted() {
  //  this.viewMontaz()
  //  this.dragdropCanvas()
  //  this.dragdropCanvasTest()
   this.dragdropCanvasTestClass()
    // window.addEventListener('resize', this.getDimensions);
  },
  unmounted() {
    // window.removeEventListener('resize', this.getDimensions);
  }
};
</script>

<style>
#CanvasCorrect {
  display: inline-flex;
  width:100%;
}
.hello input {
  width: 135px;
}
.hello {
  height: 100%;
}

.wrapper {
  display: table;
  padding: 0;
  width: 100%;
  height: 100%;
  /* position: absolute; */
}

.container {
  /* display: table-cell;
  vertical-align: middle; */
  display: block;
  margin-top: 20px;
}

.canvas-container {
  position: relative;
  /* max-width: 1024px;
  min-width: 320px; */
  margin: 0 auto;
  width: 100%;
  height: 100%;
  text-align: left;
}

#obudowa {
  width: 100%;
  height: auto;
  z-index: 0;
}
#centrala {
  width: 100%;
  height: auto;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
}

#terrain {
  width: 100%;
  height: auto;
  /* background-color: pink; */
  z-index: 0;
}

#player {
  width: 100%;
  height: auto;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
}

#environment {
  width: 100%;
  height: auto;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
}

#modul {
  width: 100%;
  height: auto;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 3;
}

#hud {
  width: 100%;
  height: auto;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 3;
}

#resize-me span {
  background: #000;
  color: #fff;
  font-family: arial, sans-serif;
  text-align: center;
  font-weight: bold;
  padding: 5px 40px;
  line-height: 2rem;
  width: 200px;
  position: absolute;
  top: 30px;
  right: -80px;
  -webkit-transform: rotate(45deg);
  -moz-transform: rotate(45deg);
  -o-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}

#resize-me {
  position: absolute;
  top: 0;
  right: 0;
  width: 200px;
  overflow: hidden;
  height: 200px;
  z-index: 5;
}

#tabCorrect tr td {
  padding: 5px;
  height: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/CanvasCorrectTest.vue